export default __webpack_public_path__ + "static/media/time_icon.4ddee821.png";